export default "__VITE_ASSET__DsZoLBZL__"